// @flow

import { useEffect, useState } from 'react';

/**
 * Returns true once the component has mounted on the client.
 * Useful to prevent SSR hydration mismatches.
 */
export const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState<boolean>(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};
